import { generateUnOrderedList, getCircleTypeListItem, getSquareTypeListItem, sectionStyle } from "../../../screens/JaldiLab/Chapters/ChapterList"

export const ImageDesc2 = {
    title: "Image 2: Courtroom without level differences in the new extension building of the Delhi High Court.",
    para1: "The image is of a Courtroom without level differences in the new building of the Delhi High Court. There are several rows of wooden benches facing the dais. The benches have armrests. The judges’ dais is at the same level as the benches. Large televisions are mounted on the right and left side of the Courtroom. The wooden panelling on the wall to the left has concealed storage. Lighting panels are provided in the ceiling  of the Courtroom.",
}

export const ImageDesc3 = {
    title: "Image 3: Accessible corridor with clear width at the High Court of Meghalaya.",
    para1: "The image shows a long corridor with a light colored floor and white walls in the Meghalaya High Court. Yellow coloured guiding tactile pavers are placed in a line in the middle, along the length of the corridor. There are potted plants with green leaves on the floor on both sides. The corridor is well lit.",
}

export const ImageDesc4 = {
    title: "Image 4: Accessible signage at the POCSO and Family Courts in Warangal District Courts, Telangana",
    para1: `The image depicts a sign mounted on a wall at the POCSO and Family Courts in Warangal District Court. The sign is green.  It has images of a flower and leaves and lettering in two languages. The top lettering is in English and reads "Home Garden". The lettering below it is in Telugu and reads "పెరటి తోట" (Peraṭi tōṭa). There is a hanging plant with a carrier shaped like a character in the courtyard visible in the background of the image.`,
}

export const ImageDesc5 = {
    title: "Image 5: Accessible unisex toilets at the High Court of Meghalaya",
    para1: <>
        <p>There are two images. </p>
        <p><span style={sectionStyle}>(1)</span> The first image is signage for the “ACCESSIBLE UNISEX TOILET”. The text is written in white capital letters on a blue background.  Below the text are symbols for accessible unisex toilets and braille text.
        </p>
        <p><span style={sectionStyle}>(2)</span> This image is of an accessible toilet which shows a white western water closet (WC) with an attached flush tank.  There is a vertical and a horizontal grab bar mounted on the wall to the right of the WC in an L-shaped configuration.  A toilet paper dispenser and a water faucet are fixed on the right wall at a height that is easily accessible from the seat of the WC. A hinged type / flip-up horizontal grab bar is mounted on the wall behind the WC to provide support on the left side of the WC.  There is clear space to manouevre a wheelchair in front of the WC. The floor and walls are of ceramic tiles.</p>

    </>,
}

export const ImageDesc6 = {
    title: "Image 6: Culturally relevant signage and iconography at Warangal District Court, Telangana",
    para1: <>
        <p>There are two images. </p>
        <p>
            <span style={sectionStyle}>(1)</span> The first image is a multilingual sign written in two languages. The top text is in English and reads: "Namaste! Meet Amma, Nanna, Chinni & Chinna. They will guide you through the complex to make sure you feel safe and comfortable."
        </p>
        <p>
            Below the English text is the same message written in Telugu.
        </p>
        <p>
            The sign itself is green with white lettering.
        </p>
        <p>
            <span style={sectionStyle}>(2)</span> The second image is a colorful display of six masks arranged in two columns. All the masks appear to be facing the viewer. Here’s a description of each mask:
        </p>
        <div className="figure_desc">
            {generateUnOrderedList([
                "The first mask in the first column is yellow and has a long handlebar moustache. It also has large eyes and chandan on its forehead. It also has a red turban.",
                "The second mask in the first column is red and has short black hair. It has large eyes, a big nose ring and a tattoo on her chin. It has a gold headband.",
                "The third mask in the first column is a brown mask with a golden headband. It has large eyes, a bindi on its forehead, a nose ring and a tattoo on its screen. ",
                "The first mask in the second column is blue and has a handlebar moustache. It also has large eyes and a white mark indicating chandan on its forehead.",
                "The second mask in the second column is pink and has hair in a bun. It has large eyes and a red dot in the center of the forehead.",
                "The third mask in the second column is green and has hair tied in braids. It also has large eyes and a large mouth."
            ])}
        </div>
        <p>
            The text below the masks reads  “Meet Nanna, Amma and Chinni” in English. Below the English text, there is the same message written in Telugu, which is  “మీట్ అమ్మ, నాన్న, చిన్ని” (Meeṭ Amma, Nanna, Chinni).
        </p>
    </>,
}

export const ImageDesc7 = {
    title: "Image 7: Involvement of local communities in public design elements at Warangal District Court, Telangana",
    para1: <>
        <p>
            The image depicts a flyer or poster advertising a community engagement event focused on art and painting activities.
            <div className="figure_desc">
                {generateUnOrderedList([
                    `The title reads "COMMUNITY ENGAGEMENT" in large bold letters, followed by "ART & PAINTING ACTIVITIES" in smaller letters.`,
                    `This is followed by the image of a man with a mask drawing on a yellow cloud shaped paper on the wall. The text below it reads "Wall Painting outside CRECHE Building" `,
                    `There is another image of 4 men and 1 woman standing in front of another illustration on a wall. One of the men is drawing on the wall while the others look on. The text below reads "Flying Girl from Kant Risa".`
                ])}
            </div>
        </p>
    </>,
}

export const ImageDesc8 = {
    title: "Image 8: Fire Evacuation Plan Sign",
    para1: <>
        <p>This image is an emergency evacuation plan for a building. It contains the following information:</p>
        <div className="figure_desc">
            {generateUnOrderedList([
                <>
                    <span style={sectionStyle}>Emergency Numbers: </span>There are three emergency numbers listed on the left side of the plan. The number for fire is 000, ambulance is 000, and police is 000.
                </>,
                <>
                    <span style={sectionStyle}>Evacuation Procedure: </span>There are instructions for what to do in case of a fire. The text says to evacuate immediately and not to use the elevators.
                </>,
                <>
                    <span style={sectionStyle}>Assembly Area: </span> The designated assembly area is marked with a large red X in the bottom right corner of the plan. The text next to the X says "Assembly Area."
                </>,
                <>
                    <span style={sectionStyle}>Legend: </span> The legend at the bottom of the plan explains the symbols used in the plan. Here is a description of the symbols:
                    {getCircleTypeListItem([
                        <>
                            <span style={sectionStyle}>Exit: </span>The symbol is green with white text in it stating “Exit”.
                        </>,
                        <>
                            <span style={sectionStyle}>Dry Chemical Extinguisher: </span>This symbol is a red extinguisher in a white background. The text "Dry Chemical Extinguisher" is written below the symbol.
                        </>,
                        <>
                            <span style={sectionStyle}>Carbon Dioxide Extinguisher: </span>This symbol is a red extinguisher with a black pipe in a white background. The text "Carbon Dioxide Extinguisher" is written below the symbol.
                        </>,
                        <>
                            <span style={sectionStyle}>Emergency Assembly Point: </span>This symbol is green with white text stating “Emergency Assembly Point”.
                        </>,

                    ], true)}
                </>,
                <>
                    <span style={sectionStyle}>Floor Plan: </span> The main part of the plan is a map of the building. The map shows the walls, doorways, and exits of the building. The stairwells are marked with blue squares. There is an arrow pointing north at the top of the plan which is the location of the person reading the map. The map also shows the most direct route to access the Exit point from that point.
                </>,
                <>
                    <span style={sectionStyle}>On the right corner of the map: </span>
                    {getCircleTypeListItem([
                        <>
                            <span style={sectionStyle}>Staff & Customer Car Park: </span>
                            This designates the point in the floor plan where "Staff & Customer Car Park" is located.
                        </>
                    ], true)}
                </>,
            ])}
        </div>
        <p><b>Note:</b> The image does not contain any information about the specific building for which the Fire Evacuation Plan has been made.</p>
    </>,
}

export const ImageDesc9 = {
    title: "Image 9: Phasing Plan at Kitsap County Court, Washington State (US)",
    para1: "This image is a side-by-side comparison of the Kitsap County Court at different levels of planned construction. ",
    items: <div className="figure_desc">
        {generateUnOrderedList([
            <>The image on the right refers to Phase I of the plan:
                {getCircleTypeListItem([
                    "Existing Court building",
                    "Adult Detention Facility",
                    "Space allocated for future expansion. "
                ], true)}
            </>,
            <>
                The text explanation reads:
                {getCircleTypeListItem([
                    <>“Phase 1-
                        {getSquareTypeListItem([
                            "4 floors with 12 Courtrooms",
                            "Future expansion space on site",
                            "Revise space allotment in existing Courthouse”",
                        ])}
                    </>,
                ], true)}
            </>,
            <>
                The image on the left refers to Phase 4 of the plan:
                {getCircleTypeListItem([
                    "Existing Court building",
                    "Adult Detention Facility",
                    "Additional construction at the space allocated for future expansion. "
                ], true)}
            </>,
            <>
                The text explanation reads:
                {getCircleTypeListItem([
                    <>“Phase 4-
                        {getSquareTypeListItem([
                            "Complete new court office building”",
                        ])}
                    </>,
                ], true)}
            </>
        ])}

    </div>
}

export const ImageDesc10 = {
    title: "Image 10 - Grid-frame construction of Chikkamagaluru District Court, Karnataka",
    para1: <>
        <p>
            This image depicts a picture of the Chikkamagaluru District Court in Karnataka under construction. The focus of this image is the imposing red brick Courtroom structure under construction. The intricate grid-frame design is prominent, showcasing that the Court Complex is under construction.
        </p>
        <p>
            The foreground shows a vast expanse of unpaved land which is the construction site. The loose dirt suggests ongoing activity and earthwork.
        </p>
        <p>
            A large truck with materials for construction is parked in front of the under-construction Court Complex.
        </p>
    </>,
}

export const ImageDesc11 = {
    title: "Image 11- Conversion of Judge’s Chamber into Deposition Room at Karkardooma District Court Complex, Delhi.",
    para1: <>
        <p>The image shows the two phases of the conversion of a Judges’ Chamber to a Deposition Room. </p>
        <p>
            The room on the right has an arrow pointing to it stating that its is the Judge’s Chamber. The room on the right has an arrow pointing to it stating that it is the converted Deposition Room.
        </p>
        <p>
            The description of the images are as follows:
            <p><b>Judge’s Chamber</b></p>
            <div className="figure_desc">
                {generateUnOrderedList([
                    "The room on the left has a door on the left wall.",
                    "There is a desk to the left of the door for the judge. It has one chair behind it and two in front for people visiting the judge. All chairs have black leather cushions. The judge’s chair has a cushion for backrest.",
                    "There is a wall-hung mirror to the right of the door with an almirah next to it. ",
                    "There are three chairs next to the almirah and a sofa set. ",
                ])}
            </div>
            <p><b>Deposition Room</b></p>
            <div className="figure_desc">
                {generateUnOrderedList([
                    "Two pictures of the Deposition Room are shown",
                    "The picture on top has the same door on the left wall",
                    "There are two chairs, a small table, and a sofa set to the right of the door",
                    "Plants have been placed around it to make it more comfortable and welcoming. ",
                    "The picture below shows television set installed for victims to give the deposition online.",
                ])}
            </div>
        </p>
    </>,
}

export const ImageDesc12 = {
    title: "Image 12: Audio-Visual facilities in the Courtroom at Nayagarh District Court, Odisha.",
    para1: <p>
        The image shows a courtroom with the following elements:
        <div className="figure_desc">
            {generateUnOrderedList([
                "A long wooden table in the center of the room with several behind it.",
                "The table has microphones in front of it.",
                "There is a set up for several monitors facing the Court. ",
                "There is a chair to the right of this set-up for the technician to sit. ",
                "There is a witness stand to the left of the monitors. The witness stand has a chair inside it. ",
                "The dais is behind the monitors. ",
                "The dais has a mic and computer system for the judge. ",
                "The monitor for the stenographer can also be seen to the left side on the dais.",
                "There is a leather chair for the judge behind the dais. ",
                "The wall behind the dais is wood-panelled and it has a painting of Mahatma Gandhi. ",
                "The Courtroom has a false ceiling with white panels. ",
                "There are lights and fans hung from the ceiling.",
                "Two ACs can be seen on the left wall of the Courtroom.  ",
            ])}
        </div>
    </p>,
}

export const ImageDesc13 = {
    title: "Image 13: Modular furniture at e-Seva Kendra, High Court of Karnataka.",
    para1: <>
        <p>This is an image of the counter of the e-Seva Kendra from the inside. The counter has many computer systems on it with chairs in front of it. </p>
        <p>
            The outside of the Court Complex can be seen beyond the counter. Many vehicles are parked outside.
        </p>
    </>,
}

export const ImageDesc14 = {
    title: "Image 14:  Landscaped entry plaza at the United States Federal Courthouse, Seattle (US)",
    para1: <>
        <p>
            This has 2 images of the landscaping in front of the United States Federal Courthouse. The image on the left shows an aerial view of the landscaping with trees, benches and a circular lawn.
        </p>
        <p>
            The image on the right is the view from the front. It shows several trees and a water feature.
        </p>
    </>,
}

export const ImageDesc15 = {
    title: "Image 15- Example of a Welcoming Entrance Lobby.",
    para1: "This image is an entrance lobby of a Court Complex. It shows a circular high-ceiling room with two entrances. Both entrances have a baggage scanner. There are several windows towards the top part of the high-ceiling room.",
}

export const ImageDesc16 = {
    title: <>Image 16- <i>Use of green walls at the Extension Building, Delhi High Court.</i> </>,
    para1: "This image shows a green wall which is in the Extension Building of the Delhi High Court. It stretches across most of the wall visible here. The plants are a combination of low-growing creepers and small shrubs with green and variegated leaves. A wooden slatted ceiling with recessed lighting is visible above the green wall, casting a warm glow on the plants.",
}

export const ImageDesc17 = {
    title: "Image 17- Example of accessible, safe and comfortable seating.",
    para1: `This image shows a few rows of chairs for seating in an airport waiting area.  There are signs on three chairs in the first row that say "Priority Seat" in English and Japanese. The seat also has icons denoting a person with crutches, an elderly person, a pregnant person and a person with an infant. `,
}

export const ImageDesc18 = {
    title: "Image 18- Example of dedicated evacuation chair provided at emergency exit in Kempegowda International Airport Bengaluru.",
    para1: <>
        <p>There are two images showing an evacuation chair placed next to an emergency exit. The image on the left shows both the chair and the emergency exit. The chair is a bright yellow colour which makes them highly visible even in low-light conditions or smoke-filled environments, crucial for quick identification during an emergency.</p>
        <p>The emergency exit is to the right of the evacuation chair. It has a barrier in front of it. The barrier appears to be made of metal pipes and extends out from the wall around the doorway. There is a sign above the door that says “EXIT”. There are signs on the door that say "EMERGENCY EXIT ONLY" and "PUSH UNTIL ALARM SOUNDS DOOR CAN BE OPENED IN BOTH DIRECTIONS"  in both English and Kannada. </p>
        <p>There is a panel beside the door that has a red emergency alarm and a red emergency phone. </p>
        <p>There is a tactile paver on the floor in front of the door. </p>
        <p>The image on the right is a closer image of the evacuation chair described earlier. </p>
    </>,
}

export const ImageDesc19 = {
    title: "Image 19: e-Seva Kendra at the entrance to the Court Complex in Bhadrak District Court, Odisha.",
    para1: <>
        <p>There are two images of the e-Seva Kendra in the Bhadrak District Court. </p>
        <p>The image on the left is the front view of the Kendra. It shows the e-Seva Kendra counter with a board on top identifying the same in both English and Odia. There is a board to the left of the counter providing instructions regarding the services provided at the Kendra. There are two-wheeler vehicles parked in front of the space in  front of the counter. </p>
        <p>The image on the right is a picture taken from the right side of the e-Seva Kendra. In addition to the counter as described above, the image shows some of the landscaping done in the Court Complex. </p>
    </>,
}

export const ImageDesc20 = {
    title: "Image 20 - Compactor Storage Systems at Bhadrak District Court, Odisha.",
    para1: <>
        <p>There are two images of the compactor storage system used in the Bhadrak District Court. Compactor storage rooms are designed to maximize storage capacity by using movable shelving systems on tracks, which glide to create a single access aisle when needed. </p>
        <p>The image on the left shows the compactor storage system when they are closed. Each of the movable storage compartments has been labelled with the kind of cases that are stored in that shelf. </p>
        <p>The image on the right shows the compactor storage system when it has been opened. The image shows a partial view of the shelves within the compartments with the files in them. The compartments are labelled and one of the compartments also has a picture of a deity.</p>
    </>,
}

export const ImageDesc21 = {
    title: "Image 21: Building Management System at Dharwad District Court, Karnataka",
    para1: <>
        <p>This is the image of the facade of the Court Complex at Dharwad District in Karnataka. This Court Complex is known to have incorporated a building management system with 2,500 points for monitoring and control, and an Access Control System with 52 door controllers.</p>
        <p>The picture shows a large red brick building with 6 floors. The building has many windows. There is an extended portico in front of the building at the center part of it. Some cars and other vehicles can be seen parked in front of the building. There is some landscaping done in front of it as well.</p>
    </>,
}

export const ImageDesc22 = {
    title: "Image 22- Sustainable design of National Judicial Academy (Bhopal).",
    para1: "This image shows the building of the National Judicial Academy in Bhopal. The building is built stepped along the slope of the site and terraces have been created at each level. The terraces at all levels have greenery to help integrate the building with the natural surroundings. ",
}

export const ImageDesc23 = {
    title: "Image 23: Courtyard at Warangal District Court, Telangana",
    para1: <>
        <p>The image shows the courtyard of the Warangal District Court in Telangana. The courtyard has a checkered layout with alternating grass and stone or tile pattern. The checkered part also forms part of the pathway to one of the entrances to the part of the court building visible in the picture. The building in the background has a white exterior with black columns flanking the entrance. There is a black awning over the entrance. To the right of the path, there are some green plants and bushes. </p>
        <p>There is a large tree at the center of the courtyard with a raised surface around the trunk for people to sit.</p>
    </>,
}

export const ImageDesc24 = {
    title: "Image 24: Facade at the Extension Building, Delhi High Court.",
    para1: "This image is the facade of the Extension Building at the Delhi High Court in India. The building has been designed to have geometric patterns on some vertical stone panels similar to the older historic Court building, associating it with the old Delhi High Court building’s historic context. ",
}

export const ImageDesc25 = {
    title: "Image 25: Facade at the Krushi Bhawan, Odisha.",
    para1: <>
        <p>This image shows the facade of the Krushi Bhawan which is a government building in Bhubaneswar, Odisha. The most striking feature of the facade is the intricate geometric pattern created by a system of terracotta brick louvers which is inspired by Odisha Ikat which is a traditional fabric dyeing technique from the region. The use of local motifs and materials helps to connect the building to its cultural heritage.</p>
        <p>There is some landscaping on either side of the entrance to the building which is also made of terracotta bricks.</p>
    </>,
}


export const ImageDesc26 = {
    title: "Image 26: Sustainable ventilation and design strategies at National Judicial Academy (Bhopal)",
    para1: "This image is of the facade National Judicial Academy in Bhopal showing one side of the building and the landscaping in front of it. The image shows the pergola running along the periphery of the building and courtyards that shades the corridors and regulates the climate in the interiors as well. The building is also painted white in colour. ",
}

export const ImageDesc27 = {
    title: "Image 27: Use of green building concepts at Indira Paryavaran Bhawan (Delhi). ",
    para1: "The image shows the India Paryavaran Bhawan in Delhi. The building is an example of green building concepts and the image shows multiple solar panels on the top of the building. The building has multiple floors with windows  which are highlighted with white paint allowing natural light. The building also blue murals on the left and right borders. The building reportedly uses 70% less energy compared to a conventional building. ",
}

export const ImageDesc28 = {
    title: "Image 28: Solar-powered Court Complex at Khunti District Court, Jharkhand",
    para1: "This image shows the multiple solar panels fixed on the terrace of the District Court Complex in Khunti District. It is reported to be India’s first solar powered District Court Complex. ",
}

export const FigureDesc12 = {
    title: "Figure 12: Key to the five Design Principles. ",
    para1: <>
        <p>
            This figure shows the icons which have been used to represent the five Design Principles outlined in the Handbook - accessibility, adaptability, comfort & safety, efficiency, and sustainability. Each icon has a different colour.
            <div className="figure_desc">
                {generateUnOrderedList([
                    "The accessibility icon has an image of a person in a wheelchair and is prussian blue in colour.",

                    "The adaptability icon has an image of two cubes stacked on top of a row of two other cubes.  One of the cubes on the top is depicted in dotted lines to indicate possibility of future expansion. The icon is red in colour.",

                    "The comfort & safety icon has an image of an umbrella-like shelter with icons of three persons under it and is cyan green in colour.",

                    "The efficiency icon has an image of a wheel with a clock in the centre and icons of three persons arranged in a circle around the wheel to indicate systems in process. The icon is orange in colour. ",

                    "The sustainability icon has an image of a building with a sloping roof within which is a stalk with two leaves indicating a green building. The icon is green in colour.",

                ])}
            </div>
        </p>
    </>,
}

export const FigureDesc13 = {
    title: "Figure 13: An illustrative representation of how to read the guidelines.",
    para1: <>
        <p>
            This figure is an illustrative example of how to read the visual layout of the guidelines under each Design Principle. The figure shows a screenshot of the layout design for a sample Design Principle and sample guidelines under it, with arrows being used to highlight and describe the specific parts outlined below:

            {getCircleTypeListItem([
                <>
                    <span><b>Principle</b> </span>
                    The heading of each principle. The sample image shows “2.4: Efficiency” as an example.
                </>,
                <>
                    <span><b>Background:</b> </span>
                    The background statement outlines the reasons for the design guidelines and the goals that the Principle can achieve. It helps inform application of the guidelines, but does not serve as approval criteria.
                </>,
                <>
                    <span><b>Guidelines:</b> </span>
                    Each principle has a set of Guidelines, which serve as approval criteria.
                </>,
                <>
                    <span><b>Additional information:</b> </span>
                    Guidelines are followed by statements that indicate how the guideline may be met. It includes some best practice examples and photographs.
                </>,

            ], false, "1")}
        </p>
    </>,
}

export const FigureDesc14 = {
    title: "Figure 14: An overview of the design guidelines for the Accessibility Principle.",
    para1: <>
        <p>
            This figure provides an overview of the design guidelines outlined as part of the Accessibility Principle, and the icon used to represent it.
        </p>
        <p>
            The four design guidelines are as follows:
            {getCircleTypeListItem([
                "Provide inclusive and accessible facilities & infrastructure",

                "Provide legible & accessible information & wayfinding systems",

                "Ensure accessible and culturally relevant design for diverse users",

                "Ensure accessible emergency preparedness & evacuation systems",
            ], false, "1")}
        </p>
    </>,
}

export const FigureDesc15 = {
    title: "Figure 15:  Universal Design India Principles: The Five Principles",
    para1: <>
        <p>
            The figure is developed from the Harmonised Guidelines 2021, and outlines the five Universal Design India Principles. Each of the principles is represented with an icon. The Five Principles are:
            {getCircleTypeListItem([
                "Equitable (Samaan) - Design for diverse Indian users",

                "Usable (Sahaj) - The design is operable by all Indian users",

                "Cultural (Sanskritik) - Design respects cultural past & aids all Indian users ",

                "Economy (Sasta) - Design respects affordability & aids all diverse Indian users",

                "Aesthetics (Sundar) - Design uses aesthetics for social integration among Indian users",

            ], false, "1")}
        </p>
    </>,
}

export const FigureDesc16 = {
    title: "Figure 16: An overview of the design guidelines for the Adaptability Principle. ",
    para1: <>
        <p>
            This figure provides an overview of the design guidelines outlined as part of the Adaptability Principle, and the icon used to represent it.
        </p>
        <p>
            The four design guidelines are as follows:
            {getCircleTypeListItem([
                "Anticipate and plan for future growth of Court functions",

                "Provide a scalable and flexible building structure",

                "Design adaptable and convertible workspaces ",

                "Provide flexible infrastructure to accommodate changes",
            ], false, "1")}
        </p>
    </>,
}

export const FigureDesc17 = {
    title: "Figure 17: An overview of the design guidelines for the Comfort and Safety Principle.",
    para1: <>
        <p>
            This figure provides an overview of the design guidelines outlined as part of the principle of Comfort and Safety, and the icon used to represent it.
        </p>
        <p>
            The four design guidelines are as follows:
            {getCircleTypeListItem([
                "Adopt design strategies to mitigate security risks for all people and property",

                "Design the internal environment of buildings for users’ well-being",

                "Provide common amenities designed for the comfort for all users",

                "Provide infrastructure and systems for safety incase of emergencies",
            ], false, "1")}
        </p>
    </>,
}

export const FigureDesc18 = {
    title: "Figure 18: An overview of the design guidelines for the Efficiency Principle.",
    para1: <>
        <p>
            This figure provides an overview of the design guidelines outlined as part of the Efficiency Principle, and the icon used to represent it.
        </p>
        <p>
            The three design guidelines are as follows:
            {getCircleTypeListItem([
                "Plan & design spaces for optimal use",

                "Provide facilities that meet the needs of the users",

                "Adopt efficient building operations and management systems",
            ], false, "1")}
        </p>
    </>,
}

export const FigureDesc19 = {
    title: "Figure 19: An overview of the design guidelines for the Sustainability Principle.",
    para1: <>
        <p>This figure provides an overview of the design guidelines outlined as part of the Sustainability Principle, and the icon used to represent it. </p>
        <p>
            The three design guidelines are as follows:
            {getCircleTypeListItem([
                "Optimise site potential & adopt sustainable site planning practices",

                "Provide context sensitive approach to building design",

                "Optimise carbon reduction, reduce environmental impact & increase building lifecycle",
            ], false, "1")}
        </p>
    </>,
}




